import React from 'react';
import { FormattedNumber } from 'react-intl';
import { Table, Dropdown } from 'semantic-ui-react';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { formatDateOnly } from '../../utilities/dateUtils';
import { MULTI_SUBSCRIPTION_ENABLED } from '../../config';

const ListRow = (actionHandler, isDisable, latestExpiredIds = new Set()) => subscription => {
  const activeEnableActions = endDate => {
    const endDateObj = moment(endDate, 'YYYY-MM-DD');
    if (
      !isEmpty(endDate)
      && endDateObj.isValid()
      && endDateObj < moment(new Date(), 'YYYY-MM-DD')
    ) {
      return false;
    }
    return true;
  };

  const rowMenuOptions = endDate => {
    const enableDisableOption = !activeEnableActions(endDate);
    const enableDisableOptionTitle = enableDisableOption
      ? 'Enable Subscription'
      : 'Disable Subscription';
    const disableOption = !enableDisableOption;
    const classNameOption = enableDisableOption ? '' : 'textColorGray';

    const menuOptions = [
      { key: 1, text: 'Edit', value: 'Edit' },
      {
        key: 2,
        text: enableDisableOptionTitle.toString(),
        value: enableDisableOptionTitle.toString(),
        disabled: disableOption,
        className: classNameOption,
      },
      { key: 3, text: 'Preferences', value: 'Preferences' },
      { key: 4, text: 'Edit Notes', value: 'Edit Notes' },
    ];
    return menuOptions;
  };

  const {
    id,
    productName,
    priceDs,
    pricePsiLpi,
    notifyEmail,
    networkPlusRate,
    startDate,
    endDate,
    active,
    dsPaidPsi,
    priceStartDate,
  } = subscription;

  const dsPaidPsiValue = dsPaidPsi ? 'active' : 'inactive';

  const currencyProps = price => {
    return {
      currency: 'USD',
      style: 'currency',
      minimumFractionDigits: 0,
      value: price,
    };
  };

  const handleActionChange = (e, { value }) => {
    e.preventDefault();
    actionHandler(value, subscription);
  };

  const isExpiredOrInactive = MULTI_SUBSCRIPTION_ENABLED
    ? (!isEmpty(endDate) && moment(endDate).isBefore(moment(), 'day') && !latestExpiredIds.has(id))
    : !active;

  return (
    <Table.Row key={id} active={isExpiredOrInactive} data-testid='subscription-row'>
      <Table.Cell>{productName}</Table.Cell>
      <Table.Cell>{priceStartDate}</Table.Cell>
      <Table.Cell>
        {!isEmpty(priceDs) ? (
          ''
        ) : (
          React.createElement(FormattedNumber, currencyProps(priceDs))
        )}
      </Table.Cell>
      <Table.Cell>
        {!isEmpty(pricePsiLpi) ? (
          ''
        ) : (
          React.createElement(FormattedNumber, currencyProps(pricePsiLpi))
        )}
      </Table.Cell>
      <Table.Cell className='rowEmailStyle'>
        {!isEmpty(notifyEmail)
          && notifyEmail
            .split(/(?:,)|(?:;)/gi)
            .map(element => <p key={element}>{element}</p>)}
      </Table.Cell>
      <Table.Cell>{networkPlusRate}</Table.Cell>
      <Table.Cell>
        {isEmpty(startDate) ? '' : formatDateOnly(startDate)}
      </Table.Cell>
      <Table.Cell>{isEmpty(endDate) ? '' : formatDateOnly(endDate)}</Table.Cell>
      <Table.Cell>{dsPaidPsiValue}</Table.Cell>
      <Table.Cell>
        <Dropdown
          text='Actions'
          options={rowMenuOptions(endDate)}
          icon='ellipsis horizontal'
          onChange={handleActionChange}
          inline
          item
          selectOnBlur={false}
          disabled={isDisable || isExpiredOrInactive}
          value={null}
          data-testid='row-actions-dropdown'
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default ListRow;
